// Generic HTTP save adapter for a custom backend (anything that isn't Supabase).
// Talks to { baseUrl, token } over REST. Values are opaque envelope strings from
// StorageManager — this adapter never inspects them.
//
//   GET    {baseUrl}/saves/{key}  -> 200 { value } | 404
//   PUT    {baseUrl}/saves/{key}     body { value }
//   DELETE {baseUrl}/saves/{key}

export class CloudAdapter {
  constructor({ baseUrl, token } = {}) {
    if (!baseUrl) throw new Error('[CloudAdapter] storage.cloud.baseUrl is required.');
    this.baseUrl = baseUrl.replace(/\/+$/, '');
    this.token = token || null;
  }

  _headers(extra = {}) {
    const h = { ...extra };
    if (this.token) h.Authorization = `Bearer ${this.token}`;
    return h;
  }

  _url(key) { return `${this.baseUrl}/saves/${encodeURIComponent(key)}`; }

  async get(key) {
    const res = await fetch(this._url(key), { headers: this._headers() });
    if (res.status === 404) return null;
    if (!res.ok) throw new Error(`[CloudAdapter] get failed: ${res.status}`);
    const body = await res.json().catch(() => null);
    return body?.value ?? null;
  }

  async set(key, value) {
    const res = await fetch(this._url(key), {
      method: 'PUT',
      headers: this._headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ value }),
    });
    if (!res.ok) throw new Error(`[CloudAdapter] set failed: ${res.status}`);
  }

  async remove(key) {
    const res = await fetch(this._url(key), { method: 'DELETE', headers: this._headers() });
    if (!res.ok && res.status !== 404) throw new Error(`[CloudAdapter] remove failed: ${res.status}`);
  }
}
